export const mathRoundPrecision = (numberOrString, precision) => {
    if(typeof numberOrString === "string") {
        numberOrString = +numberOrString;
    }

    const decimal = Math.pow(10, precision);

    return Math.round((numberOrString + Number.EPSILON) * decimal) / decimal;
}
